export default __webpack_public_path__ + "static/media/i-warning.32262326.svg";